import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";
import { Users, Star, Clock, Heart, Sparkles } from "lucide-react";

const StandUpDlaFirm = () => (
  <SeoPageLayout title="Stand-up" titleAccent="dla firm">
    <SeoSection title="Czym jest stand-up dla firm?">
      <p>Stand-up dla firm to profesjonalny występ komediowy, dopasowany do specyfiki Twojej organizacji. Komik na żywo bawi publiczność, nawiązując do realiów korporacyjnych, branżowych żartów i codziennych sytuacji biurowych. To doskonały sposób na przełamanie lodów, rozładowanie napięcia i stworzenie niezapomnianej atmosfery podczas firmowego wydarzenia.</p>
    </SeoSection>

    <SeoSection title="Dla kogo jest stand-up firmowy?">
      <p>Stand-up dla firm sprawdzi się zarówno w dużych korporacjach, jak i w mniejszych przedsiębiorstwach. Niezależnie od branży - IT, finanse, marketing, produkcja czy usługi - profesjonalny komik potrafi dopasować materiał do odbiorców. Występ komediowy doskonale pasuje do:</p>
      <SeoStyledList items={[
        "Imprez integracyjnych i wyjazdów firmowych",
        "Konferencji branżowych i spotkań networkingowych",
        "Gal firmowych i ceremonii wręczenia nagród",
        "Wydarzeń świątecznych - wigilie firmowe, imprezy noworoczne",
        "Spotkań zarządu i kickoff meetings",
        "Dni otwartych i wydarzeń employer brandingowych"
      ]} />
    </SeoSection>

    <SeoSection title="Jak wygląda przygotowanie występu?">
      <SeoNumberedSteps steps={[
        { title: "Wywiad wstępny", description: "Pytamy o charakter wydarzenia, profil gości, branżę i oczekiwania." },
        { title: "Personalizacja materiału", description: "Komik przygotowuje materiał, który idealnie trafia w gusta publiczności." },
        { title: "Dopracowanie detali", description: "Dbamy o to, by humor był inteligentny, elegancki i nigdy nie przekraczał granic dobrego smaku." },
      ]} />
    </SeoSection>

    <SeoSection title="Korzyści z zamówienia stand-upu dla firmy">
      <SeoFeatureGrid features={[
        { icon: Users, title: "Budowanie relacji", description: "Wspólny śmiech wzmacnia więzi i buduje pozytywne relacje w zespole." },
        { icon: Star, title: "Unikalna rozrywka", description: "Wyróżnij swoje wydarzenie formą, która zapada w pamięć na długo." },
        { icon: Sparkles, title: "Profesjonalizm", description: "Komik dba o dynamikę i interakcję z publicznością na najwyższym poziomie." },
        { icon: Heart, title: "Pozytywne wspomnienia", description: "Integracja pracowników, która procentuje długo po wydarzeniu." },
      ]} />
    </SeoSection>

    <SeoSection title="Ile trwa występ stand-up dla firm?">
      <p>Standardowy występ trwa od 20 do 60 minut, w zależności od formatu wydarzenia i Twoich preferencji. Oferujemy również krótsze wejścia (10-15 minut) jako element większego programu, np. podczas gali lub konferencji. Czas trwania dobieramy indywidualnie, by idealnie wpasować się w harmonogram Twojego eventu.</p>
      <SeoHighlightBox>
        Najczęściej wybierany format to 30-minutowy występ z personalizowanym materiałem - idealny balans między rozrywką a dynamiką programu.
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default StandUpDlaFirm;
